/*
 * @providesModule PlayTabStore
 */
import {
  NativeModules,
} from 'react-native';
import GlobalEventEmitter from 'GlobalEventEmitter';
import PlayableMatchesStore from 'PlayableMatchesStore';
import RESTStore from 'RESTStore';
import SKZConstants from 'SKZConstants';
import SKZTournament, {TournamentCategoryType} from 'SKZTournament';
import SKZTournamentCategories from 'SKZTournamentCategories';
import ClientPropertyConstants from 'ClientPropertyConstants';

const SKZAPIManager = NativeModules.SKZAPIManager;

const groupedTournamentTemplatesUrl = '/game/v1/grouped-tournament-templates';
const SYNC: TournamentCategoryType = 'SYNC';

class PlayTabStore {

  getGroupedTournamentTemplates(useCache: boolean = true): Promise<SKZTournamentCategories> {
    return new Promise((resolve: (response: SKZTournamentCategories) => void, reject: (error: Error | null) => void) => {
      const handleResponse = (response: SKZTournamentCategories | null, error: Error | null) => {
        if (response) {
          const groupedTournamentTemplates = new SKZTournamentCategories(response);
          const syncCategory = groupedTournamentTemplates.getCategoryForType(SYNC);
          if (syncCategory && syncCategory.tournament_template_sets instanceof Array) {
            GlobalEventEmitter.emit(SKZConstants.INIT_STAKES_SELECTOR, syncCategory.tournament_template_sets);
          }
          if (ClientPropertyConstants.isCoreLoopTungstenEnabled()) {
            PlayableMatchesStore.storeTournaments(groupedTournamentTemplates);
          }
          resolve(groupedTournamentTemplates);
        } else {
          reject(error);
        }
      };
      if (useCache) {
        RESTStore.getAnyResponse(groupedTournamentTemplatesUrl, null, SKZAPIManager.OnError.promptRetry, handleResponse);
      } else {
        RESTStore.getServerResponse(groupedTournamentTemplatesUrl, null, SKZAPIManager.OnError.promptRetry, handleResponse);
      }
    });
  }

  fetchPendingChallenges(): Promise<SKZTournament[]> {
    /**
     * PlayableMatchesStore.fetchTournamentCategories() is temporary
     * implementation of pending friends tournaments for Core Loop MVP.
     * This should be updated to the new server endpoint once it is
     * created shortly after Core Loop MVP. Note server only expects
     * /v1/tournament_categories to support load for DS.
     */
    return new Promise((resolve: (response: SKZTournament[]) => void, reject: (error: Error | null) => void) => {
      PlayableMatchesStore.fetchTournamentCategories(false).then((tournamentCategories: Object[]) => {
        if (tournamentCategories.length > 0) {
          const friendsCategory = tournamentCategories.find((category: Object) => category?.type === 'FRIENDS');
          resolve(friendsCategory?.tournaments || []);
        } else {
          resolve([]);
        }
      }).catch((error: Error) => {
        reject(error);
      });
    });
  }
}

export default new PlayTabStore();
